import React, {Component} from 'react';
import {connect} from "react-redux";
import {compose} from "redux";

import {firestoreConnect, populate} from "react-redux-firebase";
import {COMPANY_DB_PATH} from "../constants/DB_PATHS";
import {setSelectedEmployee} from "../redux/uxEnhance/action";

class EmployeeList extends Component {
    render() {
        //console.log(this.props)
        return (
            <div>
                {this.props.empList && this.props.empList !== 0 ?
                    Object.values(this.props.empList).map((e,i)=>{
                        return(
                            <div key={i} onClick={()=>{
                                console.log(e)
                                this.props.setSelectedEmployee(e.employeeId.id, e.employeeId.firstN, e.employeeId.lastN)
                            }}>
                                {e.employeeId.id} {e.employeeId.firstN} {e.employeeId.lastN}
                            </div>
                        )
                    })
                    :
                    <div>No employees</div>
                }
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return{
        setSelectedEmployee: (id, firstN, lastN) => dispatch(setSelectedEmployee(id, firstN, lastN))
    }
}

export default compose(
    connect(null, mapDispatchToProps),
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile,
        })
    ),
    connect((state, props) => ({
        empList: populate(state.firestore, 'empList',
            [{child: 'employeeId', root: 'users'}]),
        //empList: state.firestore.ordered.empList
    })),
    firestoreConnect(props => {
       /* console.log('fc')
        console.log(props)
        console.log('isloaded', props.auth.isLoaded)
        console.log('isempty', !props.auth.isEmpty)
        console.log('uid', props.auth.uid)*/
        if (props.auth.isLoaded && !props.auth.isEmpty && props.auth.uid) {
            return [
                {
                    collection: COMPANY_DB_PATH,
                    doc: props.auth.uid,
                    storeAs: 'empList',
                    subcollections: [
                        {
                            collection: 'employees',
                        },
                    ],
                    populates: [{child: 'employeeId', root: 'users'}],
                }
            ]
        }

    }),
)(EmployeeList)